export const UltimateDestination = ({ os }) => {
  return (
    <div className="watchoDownloadUltimateDestinationContainer">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 order-2 order-lg-0">
            <div className="mobileImageContainer">
              <img src="../Images/WatchoDownloadLP/ph-1.png" />
              <img src="../Images/WatchoDownloadLP/ph-2.png" />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="ultimateDestinationTxtContainer">
              <h6>
                <span>vzy:</span> your ultimate entertainment destination
              </h6>
              <p>
                Offering exclusive creator content, live TV, 24+ OTT apps, and
                much more, all in one place. Dive into endless streaming
                possibilities with vzy – the only platform you need.
              </p>
            </div>
            <div className="watchoQrCode d-none d-lg-block">
              <img src="../Images/WatchoDownloadLP/qrCode.png" />
            </div>
            <div className="watchoDownloadBtn text-center d-block d-lg-none">
              {os === "iOS" ? (
                <a
                  className="btn btn-primary w-100 w-md-auto"
                  target="_blank"
                  href="https://lets.vzy.one/BshTkVATkTb"
                >
                  Download the App Now
                </a>
              ) : (
                <a
                  className="btn btn-primary w-100 w-md-auto"
                  target="_blank"
                  href="https://lets.vzy.one/BshTkVATkTb"
                >
                  Download the App Now
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
